import _ from 'lodash'
import {
  getParent,
  generateUUID,
  parseAtlasDependece,
  getDirectoryByPage,
  DFSForLanguageNodes,
} from '@ps/utils/game'
import { AssetType, GamePage, AssetRoute } from '@ps/utils/config'
import { readFile, saveFile, updateVar } from '@ps/api/editor/file'
import { Base64 } from 'js-base64'
import _flatten from 'lodash/flatten'
import router from '@ps/router'
import { projectBasicPath } from '@ps/workbench/config'
import { isSquaredUp, isText, isSequenceFrame } from '@ps/bridge/qc/base'
import store from '@ps/store'
import gameIframe from '@ps/bridge/iframe/iframe'
import assets from '@ps/bridge/qc/assets'
import scriptManager from '@ps/bridge/qc/scripts/manager'
import { getBinUuidFromFiles } from '@ps/bridge/qc/bin'
import { getAddNewPrefabAction, executeAction } from '@ps/workbench/undo-redo'
import { downloadZip, assetUpdate, assetCreate } from '@ps/api/editor/prefab'
import { downloadFile } from '@ps/utils/navagitor'
import {
  isVideo,
  isAudio,
  isScene,
  checkNineIsModify,
} from '@ps/bridge/qc/base'
import * as videoScript from '@ps/bridge/qc/scripts/video'
import * as audioScript from '@ps/bridge/qc/scripts/audio'
import { replaceJpegToJpg } from '@com/utils/file'
import {
  getDescendants,
  resetNodeDefaultLayout,
} from '@ps/bridge/qc/node/utils'
import { addLanguageScriptAfterAddTextNode } from '@ps/workbench/layer/text'
import { saveGlobalUrlMap } from '@ps/bridge/resource/global-url-map'
import { getAllBinFiles } from '@ps/bridge/qc/scripts/movie-clip'
import { saveAs } from '@ps/api/common/asset'
import { wrapAddIvNode } from '@ps/store/interactive-video/brain/brain'

async function loadDependence(dependenceFiles) {
  if (dependenceFiles.length === 0) return true
  await Promise.all(
    dependenceFiles.map((item) =>
      assets.load({
        uuid: item.uuid,
        url: item.key,
        override: true,
      }),
    ),
  )
  return true
}

async function loadScripts(scripts) {
  if (scripts.length === 0) return true
  await Promise.all(
    scripts.map((item) =>
      scriptManager.load({
        id: Number(router.currentRoute.query.id),
        src: item,
      }),
    ),
  )
  return true
}

const recordHistory = async ({
  node,
  parent,
  index,
  activeUuid,
  record,
  realNode,
}) => {
  return executeAction({
    action: getAddNewPrefabAction({
      newValue: {
        node,
        parent,
        index,
        realNode,
      },
      oldValue: {
        node,
        activeUuid,
      },
    }),
    record,
  })
}
// 资源名字太长时做剪短，一般是粒子图片
function cutNameTooLong(finalName) {
  if (!/^res\//.test(finalName)) {
    return finalName
  }
  const tempName = finalName.slice(0, finalName.lastIndexOf('.'))
  const suffix = finalName.slice(finalName.lastIndexOf('.'))
  let realName = tempName.slice(tempName.lastIndexOf('/') + 1)
  const maxLength = 90
  if (realName.length > maxLength) {
    realName = realName.slice(0, maxLength)
    if (tempName.lastIndexOf('/') > -1) {
      realName = tempName.slice(0, tempName.lastIndexOf('/')) + '/' + realName
    }
    return realName + suffix
  }
  return finalName
}

export default {
  namespaced: true,

  state: {
    saveAsDialog: {
      title: '粒子信息',
      visible: false,
      appendToBody: true,
      modal: true,
      width: '800px',
      top: '88px',
      uuid: '',
      onReplaced: () => {},
    },
  },

  mutations: {
    openSaveAsDialog(state) {
      state.saveAsDialog.visible = true
    },
    closeSaveAsDialog(state) {
      state.saveAsDialog.visible = false
    },
  },

  actions: {
    /**
     * 对某个节点保存成预设
     * @param {node} 待保存的节点
     * @param {imgFile} 封面图的url
     * @param {imgBase64} 封面图base64
     * @param {download} true为下载,false保存
     * @param {isCreate} true为新建模板,false为保存
     * @param {prefabId} 预设的Id
     * @param {prefabName} 预设的自定义名字,没有则默认用节点的名字
     * @param {isSaveAs} 是否是另存为模式
     * @param {ext} 另存为的附带信息
     */
    async savePrefab(
      { rootState },
      {
        node,
        imgFile,
        imgBase64,
        prefabId,
        prefabName,
        download,
        isCreate,
        isSaveAs,
        ext,
      },
    ) {
      const projectKey = router.currentRoute.query.id
      if (typeof node === 'undefined') {
        node = rootState.workspace.game.activeNode
      }
      if (typeof prefabName === 'undefined') {
        prefabName = node.name
      }
      prefabName = prefabName.replace(/\s/g, '')
      const dependences = {}
      const content =
        rootState.workspace.game.data.gameObj.serializer.buildBundle(
          node,
          dependences,
        )
      content.dependences =
        rootState.workspace.game.data.gameObj.serializer.combineDependence(
          dependences,
        )
      const meta = {}
      meta.uuid = generateUUID()
      meta.type = AssetType.ASSET_PREFAB
      meta.source = ['.prefab']
      const binArr = []
      binArr.push(JSON.stringify(meta))
      let binContent
      let AtlasDependences = []
      const promises = []
      const pathDep = []
      for (const i in content.dependences) {
        if (content.dependences[i].key === content.dependences[i].uuid) {
          // eslint-disable-next-line no-continue
          continue
        }
        let path = content.dependences[i].key
        // 有些依赖图片的路径是从project/preview开始，要去掉前面的project/preivew
        path = content.dependences[i].key.replace(
          `${projectBasicPath}${projectKey}/`,
          '',
        )
        pathDep.push(path)
        promises.push(readFile({ pid: projectKey, path }))
      }
      const sequenceFrames = getDescendants(node).filter((item) =>
        isSequenceFrame(item),
      )
      sequenceFrames.forEach((sequenceFrame) => {
        const allFrame = getAllBinFiles(sequenceFrame)
        const frames = allFrame.split(',')
        frames.forEach((frame) => {
          frame = frame.replace(/\.\//g, '')
          if (!pathDep.includes(frame)) {
            pathDep.push(frame)
            promises.push(readFile({ pid: projectKey, path: frame }))
          }
        })
      })
      // 场景节点需要保存视频和音频
      if (isScene(node)) {
        const promisesMedia = []
        const mediaName = []
        node.children.forEach((child) => {
          if (isVideo(child)) {
            const video = videoScript.getScript(child, false)
            promisesMedia.push(
              readFile({ pid: projectKey, path: video.videoUrl, base64: 1 }),
            )
            mediaName.push(
              prefabName +
                '/res/' +
                video.videoUrl.slice(video.videoUrl.lastIndexOf('/') + 1),
            )
            if (video.audioUrl) {
              promisesMedia.push(
                readFile({ pid: projectKey, path: video.audioUrl, base64: 1 }),
              )
              mediaName.push(
                prefabName +
                  '/res/' +
                  video.audioUrl.slice(video.audioUrl.lastIndexOf('/') + 1),
              )
            }
          } else if (isAudio(child)) {
            const audio = audioScript.getScript(child, false)
            promisesMedia.push(
              readFile({ pid: projectKey, path: audio.audioUrl, base64: 1 }),
            )
            mediaName.push(
              prefabName +
                '/res/' +
                audio.audioUrl.slice(audio.audioUrl.lastIndexOf('/') + 1),
            )
          }
        })
        if (promisesMedia.length > 0) {
          await Promise.all(promisesMedia).then((res) => {
            res.forEach((item, index) => {
              AtlasDependences.push({
                name: mediaName[index],
                data: item,
              })
            })
          })
        }
      }
      const rootDir = getDirectoryByPage()
      const res = await Promise.all(promises)
      const transformResourceRoute = []
      for (const index in res) {
        const oriUUID = JSON.parse(res[index][0]).uuid
        const oriResourceRoute = pathDep[index]
        const resourceName = oriResourceRoute
          .slice(oriResourceRoute.lastIndexOf('/') + 1)
          .replace(/\.bin$/g, '')
        let newResourceRoute = `resource/${prefabName}/res/${resourceName}.bin`
        // let newUUID = generateUUID()
        // 只改路径，不改uuid，加载新的预设到原项目时青瓷会把原来的uuid路径改成新的资源路径
        const lgReg = new RegExp(`${rootDir}lg_([^/]+)/`)
        const xlzReg = new RegExp(`${rootDir}xlz_([^/]+)/`)
        const langReg = new RegExp(`${rootDir}lang/`)
        let resPath
        if (lgReg.test(oriResourceRoute)) {
          const lgName = oriResourceRoute.match(lgReg)[1]
          resPath = `${prefabName}/res/lg_${lgName}/${resourceName}`
          newResourceRoute = `resource/${prefabName}/res/lg_${lgName}/${resourceName}.bin`
        } else if (xlzReg.test(oriResourceRoute)) {
          const xlzName = oriResourceRoute.match(xlzReg)[1]
          resPath = `${prefabName}/res/xlz_${xlzName}/${resourceName}`
          newResourceRoute = `resource/${prefabName}/res/xlz_${xlzName}/${resourceName}.bin`
        } else if (langReg.test(oriResourceRoute)) {
          resPath = `${prefabName}/res/${resourceName}`
          newResourceRoute = `resource/${prefabName}/res/${resourceName}.bin`
        } else {
          resPath = `${prefabName}/res/${resourceName}`
          newResourceRoute = `resource/${prefabName}/res/${resourceName}.bin`
        }
        const atlas = await parseAtlasDependece(
          resPath,
          res[index],
          oriUUID,
          pathDep[index],
        )
        AtlasDependences.push(atlas)
        transformResourceRoute.push({
          oriResourceRoute,
          newResourceRoute,
        })
      }
      // 九宫格图片参数编辑处理
      const nineConfigImages = getDescendants(node, null, false).filter(
        (item) => isSquaredUp(item) && checkNineIsModify(item),
      )
      nineConfigImages.forEach(async (node) => {
        AtlasDependences.forEach((depData) => {
          depData.forEach((data) => {
            if (/\.bin$/.test(data.name)) {
              let binData = Base64.decode(data.data)
              binData = JSON.parse(binData)
              const uuidData = JSON.parse(binData[0])
              if (uuidData.uuid === node.texture.atlas.uuid) {
                uuidData.padding = {
                  0: [
                    node.borderLeft,
                    node.borderTop,
                    node.borderRight,
                    node.borderBottom,
                  ],
                }
                binData[0] = JSON.stringify(uuidData)
                data.data = Base64.encode(JSON.stringify(binData))
              }
            }
          })
        })
      })

      binArr.push(JSON.stringify(content))
      binContent = JSON.stringify(binArr)
      transformResourceRoute.forEach((item) => {
        binContent = binContent.replace(
          new RegExp(item.oriResourceRoute, 'gm'),
          item.newResourceRoute,
        )
      })
      if (ext && ext.particleDownloadCaas) {
        binContent = binContent.replace(/"resource\//g, '"resource/common/')
      }
      AtlasDependences.push({
        name: `${prefabName}/${prefabName}.bin`,
        data: Base64.encode(binContent),
      })
      AtlasDependences.push({
        name: `${prefabName}/${prefabName}.prefab`,
        data: Base64.encode(JSON.parse(binContent)[1]),
      })
      AtlasDependences.push({
        name: `${prefabName}/${prefabName}.bin.meta`,
        data: Base64.encode(JSON.parse(binContent)[0]),
      })
      AtlasDependences = _flatten(AtlasDependences)
      if (download) {
        const zip = await downloadZip({
          filename: prefabName + '.zip',
          files: JSON.stringify(AtlasDependences),
        })
        downloadFile(zip.data.url)
        return zip
      } else if (isCreate) {
        const resCreate = await assetCreate({
          res_type: 16,
          name: prefabName,
          access_allow_pt: 2,
          files: JSON.stringify(AtlasDependences),
          img_base64: imgBase64,
        })
        return resCreate
      } else if (isSaveAs) {
        return await saveAs({
          img_file: imgFile,
          files: JSON.stringify(AtlasDependences),
          ...ext,
        })
      }
      const params = {
        id: prefabId,
        img_file: imgFile,
        img_base64: imgBase64,
        files: JSON.stringify(AtlasDependences),
      }
      // 新资源库增加from=2
      if (store.state.workspace.newResource) {
        params.from = 2
      }
      const resUpdate = await assetUpdate(params)
      return resUpdate
    },

    // isScenePrefab是否场景模板
    // style 是节点添加的初始样式
    async addNewPrefab(
      { rootState },
      { res, isScenePrefab, scene, record = true, style, parentNode },
    ) {
      res.files = res.files.map((file) => {
        return {
          ...file,
          // 由于引擎不支持 jpeg 后缀，所以需要将 jpeg 改为 jpg
          name: replaceJpegToJpg(file.name),
        }
      })

      const state = rootState.workspace.game
      const projectKey = res.projectKey
      const QCscripts = gameIframe.qici.scripts
      const newScripts = []
      const sceneUuid = scene
        ? scene.uuid
        : (rootState.workspace.game.sceneManager.currentSceneNode || {}).uuid ||
          ''
      const currentScene = parentNode || getParent(state.currentPage, sceneUuid)
      const promises = []
      const rootDir = AssetRoute.GAME_ROOT
      const uuid2url = res.uuid2url
      const binUUID = getBinUuidFromFiles({
        files: res.files,
        binFileName: res.name + '.bin',
      })
      let prefixName
      let pathPrefix = `${rootDir}`
      let finalName = ''
      let suffix = ''

      if (binUUID === '') {
        throw new Error('组件里没有找到.bin文件')
      }

      let prefabContent
      // 文件重命名
      res.files.forEach((item) => {
        let path = ''
        const realName = item.name.slice(item.name.lastIndexOf('/') + 1)
        // item.name: res/a.bin, res/a.bin.meta, a.bin -> res/a_uuid.bin, res/a_uuid.bin.meta, a_uuid.bin
        prefixName = item.name.slice(0, item.name.indexOf('.'))
        suffix = item.name.slice(item.name.indexOf('.') + 1)
        // finalName: res/a_uuid.bin or a_uuid.bin
        if (/_[0-9a-zA-Z]{15}$/.test(prefixName)) {
          // 已有md5的名字,替换尾部的md5
          finalName =
            prefixName.replace(/_[0-9a-zA-Z]{15}$/, `_${binUUID}`) +
            '.' +
            suffix
        } else {
          finalName = `${prefixName}_${binUUID}.${suffix}`
        }
        finalName = cutNameTooLong(finalName)
        // res/a.bin -> a.bin -> a_uuid.bin 把入口的bin文件相关依赖替换
        // let pureName = prefixName.slice(prefixName.lastIndexOf('/') + 1) + '.' + suffix
        // let path = ''
        let final = ''
        if (/\.(ts|mp4)$/.test(realName.toLowerCase())) {
          path = `${rootDir}video/${realName}`
        } else if (/\.mp3$/.test(realName.toLowerCase())) {
          path = `${rootDir}audio/${realName}`
        } else if (/^res\/lg_[^\\/]*\//.test(item.name)) {
          // 龙骨
          const lg = item.name.match(/^res\/lg_(.*?)\//)
          const lgName = lg[1]
          pathPrefix = `${rootDir}lg_${lgName}/`
          if (/_[0-9a-zA-Z]{15}$/.test(prefixName)) {
            // 已有md5的名字,替换尾部的md5
            finalName =
              prefixName.replace(/_[0-9a-zA-Z]{15}$/, `_${binUUID}`) +
              '.' +
              suffix
          } else {
            finalName = `${prefixName}_${binUUID}.${suffix}`
          }
          finalName = cutNameTooLong(finalName)
          final = pathPrefix + finalName.slice(finalName.lastIndexOf('/') + 1)
          prefabContent = JSON.stringify(res.json)
          prefabContent = prefabContent.replace(
            new RegExp('\\"[^"]*' + item.name + '\\"', 'g'),
            '"' + final + '"',
          )
          res.json = JSON.parse(prefabContent)
          path = final
        } else if (/^res\/xlz_[^\\/]*\//.test(item.name)) {
          // 序列帧
          const xlz = item.name.match(/^res\/xlz_(.*?)\//)
          const xlzName = xlz[1]
          pathPrefix = `${rootDir}xlz_${xlzName}/`
          final = pathPrefix + item.name.slice(item.name.lastIndexOf('/') + 1) // 序列帧的图片不加md5后缀
          prefabContent = JSON.stringify(res.json)
          prefabContent = prefabContent.replace(
            new RegExp('([\\"|,]{1})[^"|,]*' + item.name + '([\\"|,]{1})', 'g'),
            '$1' + final + '$2',
          )
          res.json = JSON.parse(prefabContent)
          path = final
        } else {
          // resource/UIImage/res/txt_002_e6KxP6HPDH45067.bin -> resource/game/UIImage/res/txt_002_e6KxP6HPDH45067_123456.bin
          const pfName = res.name
            .replace(/_/g, '')
            .replace(/^lang$/, `lang${binUUID}`)
          if (
            (res.name === GamePage.ENDING &&
              state.currentPage === GamePage.ENDING) ||
            (res.name === GamePage.START &&
              state.currentPage === GamePage.START)
          ) {
            pathPrefix = `${rootDir}`
          } else {
            // 普通图片放到外面, 环节stage下的第一级
            if (/^res\//.test(finalName)) {
              pathPrefix = `${rootDir}`
            } else {
              pathPrefix = `${rootDir}${pfName}/`
            }
          }
          // finalName: res/taobao-zh-cn_NxeHEZ3A6Nky378.bin -> taobao_NxeHEZ3A6Nky378.bin
          // 防止和多语言图片的uuid冲突
          if (/^res\//.test(finalName)) {
            finalName = finalName.replace('res/', '')
            const i1 = finalName.indexOf('-')
            if (i1 > -1) {
              const i2 = finalName.lastIndexOf('_')
              const p1 = finalName.slice(0, i1)
              const p2 = finalName.slice(i2)
              finalName = p1 + p2
              if (/\.bin$/.test(finalName)) {
                item.data = Base64.decode(item.data)
                const data1 = JSON.parse(item.data)
                const data2 = JSON.parse(data1[0])
                const oldUuid = data2.uuid
                if (
                  uuid2url.hasOwnProperty(oldUuid) &&
                  uuid2url[oldUuid].indexOf('-') > -1
                ) {
                  const newUuid = generateUUID()
                  item.data = item.data.replace(oldUuid, newUuid)
                  const key = res.json.dependences[oldUuid].key
                  delete res.json.dependences[oldUuid]
                  res.json.dependences[newUuid] = {
                    uuid: newUuid,
                    key,
                  }
                  let prefabContent = JSON.stringify(res.json)
                  prefabContent = prefabContent.replace(
                    new RegExp(oldUuid, 'g'),
                    newUuid,
                  )
                  res.json = JSON.parse(prefabContent)
                }
                item.data = Base64.encode(item.data)
              }
            }
          }
          final = pathPrefix + finalName
          prefabContent = JSON.stringify(res.json)
          prefabContent = prefabContent.replace(
            new RegExp('\\"[^"]*' + item.name + '\\"', 'g'),
            '"' + final + '"',
          )
          res.json = JSON.parse(prefabContent)
          // 开始页面和结束页面不需要重命名start.bin和ending.bin
          const noNeedRename = [
            AssetRoute.ENDING,
            AssetRoute.ENDING.replace('.bin', '.prefab'),
            AssetRoute.ENDING.replace('.bin', '.bin.meta'),
            AssetRoute.START,
            AssetRoute.START.replace('.bin', '.prefab'),
            AssetRoute.START.replace('.bin', '.bin.meta'),
          ]
          if (noNeedRename.indexOf(pathPrefix + item.name) > -1) {
            path = pathPrefix + item.name
          } else {
            path = pathPrefix + finalName
          }
        }
        const promise = saveFile(
          { pid: res.projectKey, path, enc: 'base64' },
          item.data,
        )
        promises.push(promise)
        if (
          suffix === 'js' &&
          QCscripts.indexOf(pathPrefix + finalName) === -1
        ) {
          QCscripts.push(pathPrefix + finalName)
          newScripts.push(pathPrefix + finalName)
        }
      })
      // 序列帧特殊处理
      prefabContent = JSON.stringify(res.json)
      prefabContent = prefabContent.replace(
        /\{0\}(.*?)\.bin/,
        '{0}$1_' + binUUID + '.bin',
      )
      res.json = JSON.parse(prefabContent)
      // 预加载资源
      const dependenceFiles = []
      for (const i in res.json.dependences) {
        // 内置的资源，不需要重新去 Load, 因此过滤掉
        if (i !== '__builtin_resource__') {
          dependenceFiles.push({
            uuid: i,
            key: res.json.dependences[i].key,
          })
        }
      }

      // 上传组件的文件
      await Promise.all(promises)
      await loadDependence(dependenceFiles)

      /**
       * 当前问题是由于在上传完所有预设以及其依赖资源后，在进行 result = new state.data.Prefab(uuid, '', res.json, res.meta) 操作时，因为当前的依赖脚本并没有添加到iframe的 QCscripts 中，导致脚本报错(缺失对象)而生产依赖项终端，从而时该 state.data.gameOb.assets._uuid2UrlConf 中并不没有出现新添加的依赖资源。但由于这个步骤中已经保存了scripts，当页面再刷新后，之前缺失的脚本就会被加载上，使得刷新页面后的 result = new state.data.Prefab(uuid, '', res.json, res.meta) 操作能够顺利执行，因此能正常添加预设
       */
      await loadScripts(newScripts)
      const result = new state.data.Prefab(binUUID, '', res.json, res.meta)
      let newNode
      if (isScenePrefab) {
        // 场景预设模板添加到gamePlay下,由于所有节点id被重置,所有不能用事件表.清空原vpAst
        const gamePlay = getParent(GamePage.GAME)
        newNode = state.data.gameOb.add.clone(result, gamePlay)
        newNode.getScript('playsmart.editor.data').vpAst = {}
      } else {
        newNode = state.data.gameOb.add.clone(result, currentScene)
        resetNodeDefaultLayout(newNode)
      }
      // 设置初始化样式
      !_.isEmpty(style) &&
        _.each(style, (value, styleKey) => {
          newNode[styleKey] = value
        })

      // 新加的预设里的每个节点去掉ps.Languages脚本,如果已有的多语言图片节点重名则改名
      DFSForLanguageNodes(newNode, (node) => {
        // 去掉不存在的脚本
        for (let i = 0; i < node.scripts.length; i++) {
          const className = node.scripts[i].class
          if (className === 'qc.NonexistScript') {
            node.scripts.splice(i, 1)
            --i
          }
        }
        const deleteScripts = ['ps.UserBehaviour', 'ps.RunCode', 'ps.Languages']
        deleteScripts.forEach((script) => {
          // 部分导入素材没有 ps.UserBehaviour 脚本，直接 getScript 会报错，因此做容错处理，如果 node 没有 UserBehaviour 属性，代表肯定不会有 ps.UserBehaviour 脚本
          if (script === 'ps.UserBehaviour' && !node.UserBehaviour) {
            return
          }
          const nodeScript = node.getScript(script)
          if (nodeScript) {
            node.removeScript(nodeScript)
          }
        })
        // 文本节点需要重置其langConfig在当前项目下的多语言信息
        if (isText(node)) {
          addLanguageScriptAfterAddTextNode({
            node,
            langs: store.state.workspace.language.languageList,
          })
        }
      })

      await saveGlobalUrlMap({
        projectKey,
        uuid2url: state.data.gameOb.assets._uuid2UrlConf,
      })

      if (QCscripts && QCscripts.length > 0) {
        const scriptResult = await updateVar({
          params: {
            pid: projectKey,
            name: 'scripts',
          },
          data: JSON.stringify(QCscripts),
        })

        if (scriptResult.code !== 0) {
          console.error(scriptResult.msg)
          throw new Error(scriptResult.msg)
        }
      }

      if (isScenePrefab) {
        return { node: newNode }
      }
      // index 可能为 -1。新增节点后，资源还未加载节点就被删除了，这种场景不需要继续执行接下去的逻辑
      const index = currentScene.getChildIndex(newNode)
      if (index >= 0) {
        // 互动视频编辑器插入节点处理
        const ivRes = await wrapAddIvNode(currentScene, newNode, index)

        await recordHistory({
          node: ivRes ? ivRes.ivGroupNode : newNode,
          realNode: newNode,
          parent: currentScene,
          index: ivRes ? ivRes.index : index,
          activeUuid: state.activeNode ? state.activeNode.uuid : '',
          record,
        })
        return { node: newNode }
      }
    },
  },
}
